// Api url

export const categoryUrl="/api/categories";
export const signupUrl="/api/auth/signup";
export const signinUrl="/api/auth/login";
export const productUrl="/api/products";
export const wishlistUrl="/api/user/wishlist";
export const cartUrl="/api/user/cart";
//product, category load, filter

export const LOAD_CATEGORY="LOAD_CATEGORY";
export const ERROR="ERROR";
export const IS_LOADING="IS_LOADING";
export const LOAD_PRODUCTS="LOAD_PRODUCTS";
export const FILTER_BY_CATEGORY="FILTER_BY_CATEGORY";
export const SEARCH_PRODUCT="SEARCH_PRODUCT";
export const SORT_BY_PRICE="SORT_BY_PRICE";
export const FILTER_BY_RATING="FILTER_BY_RATING";
export const PRICE_RANGE="PRICE_RANGE";
export const CLEAR_ALL="CLEAR_ALL";

//products
export const  LOAD_WISHLIST="LOAD_WISHLIST";
export const  ADD_TO_WISHLIST="ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST="REMOVE_FROM_WISHLIST";
export const ADD_TO_CART="ADD_TO_CART";
export const REMOVE_FROM_CART="REMOVE_FROM_CART";
export const UPDATE_QTY="UPDATE_QTY";
export const INC_QTY="INC_QTY";
export const DEC_QTY="DEC_QTY";

